import React from 'react';

const TableHeader = ({
  config,
  searchTerm,
  setSearchTerm,
  filters,
  handleFilterChange,
  itemsPerPage,
  setItemsPerPage,
  setCurrentPage,
  totalRecords,
  getFilterOptions,
  selectedRows,
  onExport,
  onDeleteSelected
}) => {
  return (
    <>
      <div className="card-header">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h5>{config.title}</h5>
            <p className="text-secondary f-s-14 mb-0">Total {totalRecords} records found</p>
          </div>
          
          <div className="col-md-6">
            <div className="d-flex gap-2 align-items-center justify-content-end">
              {/* Search */}
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                  style={{ paddingLeft: '35px', width: '200px' }}
                />
                <i className="iconoir-search position-absolute" style={{ left: '12px', top: '50%', transform: 'translateY(-50%)' }}></i>
              </div>
            </div>
          </div>
        </div>
        
        {/* Filters */}
        {config.filters && (
          <div className="row mt-3 align-items-center">
            <div className="col-md-12">
              <div className="d-flex gap-3 align-items-center flex-wrap">
                {config.filters.map(filter => (
                  <select
                    key={filter.key}
                    className="form-select"
                    value={filters[filter.key] || 'all'}
                    onChange={(e) => handleFilterChange(filter.key, e.target.value)}
                    style={{ width: filter.width || '150px' }}
                  >
                    <option value="all">All {filter.label}</option>
                    {getFilterOptions(filter.key).map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                ))}
                
                <select
                  className="form-select"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                  style={{ width: '80px' }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Selected rows actions */}
      {selectedRows.length > 0 && (
        <div className="card-body border-bottom">
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-secondary f-s-14">{selectedRows.length} item(s) selected</span>
            <div className="d-flex gap-2">
              <button 
                className="btn btn-danger btn-sm"
                onClick={() => onDeleteSelected(selectedRows)}
              >
                <i className="iconoir-trash"></i> Delete Selected
              </button>
              <select
                  className="form-select form-select-sm"
                  style={{ width: "120px" }}
                  onChange={(e) => {
                    if (e.target.value) {
                      onExport(e.target.value);
                      e.target.value = "";
                    }
                  }}
                >
                  <option value="">Export</option>
                  <option value="excel">Excel</option>
                  <option value="csv">CSV</option>
                  <option value="copy">Copy</option>
                </select>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TableHeader;